import PaywallProBgRebrand from '@/assets/image/free-to-pay/paywall-free-bg-mobile-jpg/paywall-free-bg-mobile-rebrand.png';
import Image, { type ImageProps } from 'next/image';

export const PaywallFreeBgMobileJpg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'paywall pro bg', ...rest } = props;

  return <Image src={PaywallProBgRebrand} alt={alt} {...rest} />;
};
